// extracted by mini-css-extract-plugin
export default {"container":"Card_container__BD0eG","capa":"Card_capa__clt8f","favoritar":"Card_favoritar__XOuNS","link":"Card_link__xl0LU"};